import { type AppDispatch, type RootState } from '../../store'

export const checkAFormSwitchAction = (data: Record<string, unknown>, advertiseID: number, unitID: number, isApproved: boolean) => async (dispatch: AppDispatch, getState: () => RootState) => {
    return {
        textNavigate: isApproved ? `/landlord/modal/approve_a_form/${unitID}/${advertiseID}` : `/landlord/modal/reject_a_form/${unitID}/${advertiseID}`,
        isSuccessful: true,
        textNotification: ''
    }
}
